import { get } from '../utils/axios'

export const getResignAPI = async () => {
  return await get('resigns')
}
